/*
 * corp-links.js - F1 Authentics links open in a new tab on desktop only.
 *
 * A new tab is helpful on a large screen, where the visitor keeps their place
 * on our page and can flick back. On a phone it is the opposite: tab switching
 * is fiddly and the back button is the expected way home, so there the link
 * navigates in place.
 *
 * target is an HTML attribute and cannot be set by a media query, so it is set
 * here and re-evaluated whenever the viewport crosses the breakpoint - the same
 * 700px the stylesheet uses for mobile.
 *
 * rel is "noopener" and deliberately NOT "noreferrer": F1 Authentics should
 * still see that the traffic came from us.
 */
(function () {
  var DESKTOP = '(min-width: 700px)';
  var PARTNER = ['f1authentics.com'];

  function isPartner(a) {
    try {
      var host = new URL(a.href, window.location.href).hostname.replace(/^www\./, '');
      return PARTNER.indexOf(host) !== -1;
    } catch (e) {
      return false;
    }
  }

  function apply() {
    var wide = !window.matchMedia || window.matchMedia(DESKTOP).matches;
    var links = document.querySelectorAll('a[href]');
    for (var i = 0; i < links.length; i++) {
      var a = links[i];
      if (!isPartner(a)) continue;
      if (wide) {
        a.setAttribute('target', '_blank');
        a.setAttribute('rel', 'noopener');
      } else {
        a.removeAttribute('target');
      }
    }
  }

  apply();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', apply);
  }
  if (window.matchMedia) {
    var mq = window.matchMedia(DESKTOP);
    if (mq.addEventListener) mq.addEventListener('change', apply);
    else if (mq.addListener) mq.addListener(apply);
  }
  /* A resize fallback as well as the media query. Real browsers fire the
     matchMedia change event, but emulated viewports do not always, and the
     cost of being sure is six lines. */
  var t;
  window.addEventListener('resize', function () {
    clearTimeout(t);
    t = setTimeout(apply, 150);
  });

  /* sections re-render as blocks are edited in the theme editor */
  document.addEventListener('shopify:section:load', apply);
})();
